import React, { useState } from 'react';
import './SignInModal.css';
import { API_BASE_URL } from '../config';

const SignInModal = ({ onClose, onSuccessfulLogin, initialMode = "login" }) => {

  const [formData, setFormData] = useState({
    email: '',
    password: '',
    rememberMe: false
  });
  const [mode, setMode] = useState(initialMode);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
    setError('');
  };

const handleSubmit = async (e) => {
  e.preventDefault();
  setIsLoading(true);
  setError('');

  try {
    const response = await fetch(`${API_BASE_URL}/${mode}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",   // needed for cookies/session
      body: JSON.stringify({
        email: formData.email,
        password: formData.password
      })
    });

    let data;
    try {
      data = await response.json();
    } catch {
      throw new Error("Invalid response format");
    }

    if (response.ok && data.status === "success") {
      localStorage.setItem("user", JSON.stringify({
          email: formData.email,
          isAuthenticated: true,
          is_admin: data.is_admin   // store admin flag
        }));
      if (formData.rememberMe) {
        localStorage.setItem("rememberedEmail", formData.email);
      } else {
        localStorage.removeItem("rememberedEmail");
      }
      onSuccessfulLogin?.();
      onClose?.();
    } else {
      setError(data.message || "Invalid credentials");
    }
  } catch (err) {
    setError(err.message || "Server error. Please try again.");
  } finally {
    setIsLoading(false);
  }
};


  return (
    <div className="signin-modal-container light-theme">
      {/* Left Side - Purple Background with Graphics */}
      <div className="signin-modal-left">
        <div className="modal-graphics-container">
          <div className="modal-floating-elements">
            <div className="modal-dot modal-dot-1"></div>
            <div className="modal-dot modal-dot-2"></div>
            <div className="modal-dot modal-dot-3"></div>
            <div className="modal-dot modal-dot-4"></div>
            <div className="modal-dot modal-dot-5"></div>
          </div>
          
          <div className="modal-main-graphic">
            <div className="modal-laptop-container">
              <div className="modal-laptop">
                <div className="modal-laptop-screen">
                  <div className="modal-chart-line"></div>
                  <div className="modal-chart-bars">
                    <div className="modal-bar modal-bar-1"></div>
                    <div className="modal-bar modal-bar-2"></div>
                    <div className="modal-bar modal-bar-3"></div>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="modal-geometric-shapes">
              <div className="modal-shape modal-shape-1"></div>
              <div className="modal-shape modal-shape-2"></div>
              <div className="modal-shape modal-shape-3"></div>
            </div>
          </div>
        </div>
        
        <div className="modal-content-text">
          <h1>Turn your ideas into reality.</h1>
          <p>Start for free and get attractive offers from the community</p>
        </div>
      </div>

           {/* Right Form Side */}
      <div className="signin-modal-right">
        <div className="modal-form-container">
          <div className="modal-logo-container">
            <div className="modal-logo"><div className="modal-logo-icon"><div className="modal-logo-shape"></div></div></div>
          </div>

          <div className="modal-form-header">
            <h2>{mode === "login" ? "Sign In to your Account" : "Create a New Account"}</h2>
          </div>

          <form onSubmit={handleSubmit} className="modal-signin-form">
            <div className="modal-form-group">
              <input
                type="email"
                name="email"
                placeholder="Email address"
                value={formData.email}
                onChange={handleChange}
                className="modal-form-input"
                required
              />
            </div>
            <div className="modal-form-group">
              <input
                type="password"
                name="password"
                placeholder="Password"
                value={formData.password}
                onChange={handleChange}
                className="modal-form-input"
                required
              />
            </div>

            {mode === "login" && (
              <div className="modal-form-options">
                <label className="modal-checkbox-container">
                  <input
                    type="checkbox"
                    name="rememberMe"
                    checked={formData.rememberMe}
                    onChange={handleChange}
                  />
                  <span className="modal-checkmark"></span>
                  Remember me
                </label>
                <a href="#" className="modal-forgot-password">Forgot password?</a>
              </div>
            )}

            {error && <div className="modal-error-message">{error}</div>}

            <button type="submit" className="modal-signin-button" disabled={isLoading}>
              {isLoading ? (mode === "login" ? "Signing In..." : "Signing Up...") : (mode === "login" ? "Sign In" : "Sign Up")}
            </button>
          </form>

          <div className="modal-signup-link">
            {mode === "login" ? (
              <p>Don't have an account? <a href="#" onClick={() => setMode("signup")}>Sign up</a></p>
            ) : (
              <p>Already have an account? <a href="#" onClick={() => setMode("login")}>Sign in</a></p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};


export default SignInModal;